import { useQuery } from '@tanstack/react-query';

import { ErgonomicWorkAnalysisKeyResultService } from '@/infra/services/ergonomic-work-analysis-key-result';
import { QUERY_KEYS } from '@/utils/query-keys';

const Service = ErgonomicWorkAnalysisKeyResultService.getInstance();

interface GetSelectedStepKeyResultsParams {
	organization_id: string;
	company_id: string;
	ergonomic_work_analysis_id: string;
	custom_report_result_ids: string[];
}

export const useGetSelectedStepKeyResults = (params: GetSelectedStepKeyResultsParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_EWA_SELECTED_STEP_KEY_RESULTS, params],
		queryFn: async () => Service.findAll(params),
		enabled:
			!!params.organization_id &&
			!!params.company_id &&
			!!params.ergonomic_work_analysis_id &&
			(params.custom_report_result_ids?.length ?? 0) > 0
	});
};
